export const REDUCER_NAME = "homeSponsors";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_HOMESPONSORS = `${REDUCER_NAME}/SET_HOMESPONSORS`;
